<template>
  <span
    class="tw-inline-flex tw-items-center before:tw-mr-2 before:tw-block before:tw-size-2 before:tw-rounded-full"
    :class="{
      [statusStyle.beforeClass]: true,
      'before:tw-animate-blink': loading,
    }"
  >
    {{ label }}
  </span>
</template>

<script lang="ts">
import { type PropType, computed } from 'vue';
import { type Status as ComponentState } from '../interfaces/Status';

type StatusStyle = {
  bgColor?: string;
  beforeClass?: string;
};

const StatusStylesMap: Record<ComponentState, StatusStyle> = {
  none: {
    bgColor: /* tw */ 'tw-bg-gp-rhino',
    beforeClass: /* tw */ 'before:tw-bg-gp-rhino',
  },
  success: {
    bgColor: /* tw */ 'tw-bg-gp-green',
    beforeClass: /* tw */ 'before:tw-bg-gp-cyan',
  },
  danger: {
    bgColor: /* tw */ 'tw-bg-gp-fire',
    beforeClass: /* tw */ 'before:tw-bg-gp-fire',
  },
  warning: {
    bgColor: /* tw */ 'tw-bg-gp-orange',
    beforeClass: /* tw */ 'before:tw-bg-gp-orange',
  },
  info: {
    bgColor: /* tw */ 'tw-bg-gp-ocean',
    beforeClass: /* tw */ 'before:tw-bg-gp-ocean',
  },
};

export default {
  props: {
    state: {
      type: String as PropType<ComponentState>,
      default: 'none',
    },
    label: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const statusStyle = computed<StatusStyle>(() => {
      if (props.state === 'none') return {};
      return StatusStylesMap[props.state];
    });
    return {
      statusStyle,
    };
  },
};
</script>
